/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PageInfo
 */
export interface PageInfo {
    /**
     * 
     * @type {number}
     * @memberof PageInfo
     */
    totalPages: number;
    /**
     * 
     * @type {number}
     * @memberof PageInfo
     */
    pageSize: number;
    /**
     * 
     * @type {number}
     * @memberof PageInfo
     */
    totalCount: number;
}

/**
 * Check if a given object implements the PageInfo interface.
 */
export function instanceOfPageInfo(value: object): value is PageInfo {
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    return true;
}

export function PageInfoFromJSON(json: any): PageInfo {
    return PageInfoFromJSONTyped(json, false);
}

export function PageInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'totalPages': json['totalPages'],
        'pageSize': json['pageSize'],
        'totalCount': json['totalCount'],
    };
}

export function PageInfoToJSON(json: any): PageInfo {
    return PageInfoToJSONTyped(json, false);
}

export function PageInfoToJSONTyped(value?: PageInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['totalPages'],
        'pageSize': value['pageSize'],
        'totalCount': value['totalCount'],
    };
}

